import normalizeUrl from "src/features/HomepageCarouselBanners/utils/normalizeUrl";

const adaptEditBanner = (id: number, data: BannerFormState): CarouselBanner => {
	const result = {
		id,
		variant: data.bannerStyle,
		template: data.bannerType,
		banner_type: (data.steps[0].value?.toLowerCase() || "internal") as
			| "internal"
			| "sponsored",
		content_color: data.steps[3].fields![0].givenAnswer as
			| BannerVariant
			| "accent",
		heading_text: data.steps[3].fields![1].givenAnswer,
		content_text: data.steps[3].fields![2].givenAnswer,
		button_style: data.steps[4].fields![0].givenAnswer as BannerVariant,
		button_text: data.steps[4].fields![1].givenAnswer,
		button_visible: data.steps[4].isStepDisabled ? false : true,
		button_link: normalizeUrl(
			data.bannerStyle === "standard"
				? data.steps[4].fields![2].givenAnswer
				: data.steps[4].fields![3].givenAnswer
		),
		name: data.steps[5].fields![0].givenAnswer,
		image_portrait_uuid:
			data.steps[1].fields && data.steps[1].fields[0].givenAnswer
				? data.steps[1].fields[0].givenAnswer
				: null,
		image_landscape_uuid:
			data.steps[1].fields && data.steps[1].fields[1].givenAnswer
				? data.steps[1].fields[1].givenAnswer
				: null,
		video_uuid: data.steps[2].value ? data.steps[2].value : null,
		published: false
	} as CarouselBanner;

	// For promotions, derive button visibility from link presence
	if (
		data.bannerType === "promotionImage" ||
		data.bannerType === "promotionVideo"
	) {
		const hasLink = Boolean(result.button_link);
		result.button_visible = hasLink;
		if (!result.button_text) result.button_text = "Read more";
		if (!result.button_style) result.button_style = "black" as BannerVariant;
	}

	// Don't send incorrect assets
	if (
		data.bannerType === "singleBanner" ||
		data.bannerType == "fullImageBanner" ||
		data.bannerType === "promotionImage" ||
		data.bannerType === "fullScreenTakeoverBanner"
	) {
		delete result.video_uuid;
	}

	if (
		data.bannerType === "videoBanner" ||
		data.bannerType === "promotionVideo"
	) {
		delete result.image_portrait_uuid;
		delete result.image_landscape_uuid;
	}

	if (data.bannerType === "promotionImage") {
		delete result.image_portrait_uuid;
	}

	return result;
};

export default adaptEditBanner;
